import { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { Colors } from '@mercator-gcp/grout';
import { OverlayView } from '@react-google-maps/api';
import SelectedProjectList from 'pages/ProjectInsights/ProjectLists/SelectedProjectList';
import { IdentifiableCoords } from 'types/map';

type ProjectListOverlayProps = {
  activeMarker: IdentifiableCoords;
  freezeZoom: () => void;
  resumeZoom: () => void;
  setActiveMarker: (marker: IdentifiableCoords) => void;
  setSelectedMapMarkerAddress: (address: string) => void;
  setSelectedClusterId: (clusterId: string) => void;
};

const projectListContainer = {
  position: 'absolute',
  bottom: '100%',
  borderRadius: '4px',
  background: Colors.White,
  transform: 'translate(-50%, -40px)',
  width: '424px',
  maxHeight: '400px',
  overflowY: 'auto',
};

const ProjectListOverlay = ({
  activeMarker,
  setSelectedMapMarkerAddress,
  freezeZoom,
  resumeZoom,
  setActiveMarker,
  setSelectedClusterId,
}: ProjectListOverlayProps) => {
  useEffect(() => {
    return () => {
      setActiveMarker({} as IdentifiableCoords);
      setSelectedMapMarkerAddress('');
      setSelectedClusterId('');
    };
  }, [setActiveMarker, setSelectedMapMarkerAddress, setSelectedClusterId]);

  if (!activeMarker) return null;

  return (
    <OverlayView
      position={{ lat: activeMarker.lat, lng: activeMarker.lng }}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <Box sx={projectListContainer} onMouseEnter={freezeZoom} onMouseLeave={resumeZoom}>
        <SelectedProjectList lat={activeMarker.lat} lng={activeMarker.lng} />
      </Box>
    </OverlayView>
  );
};

export default ProjectListOverlay;
